"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRenderingDates = ServiceRenderingDates;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var service_1 = require("../features/apis/service");
/**
 * "Correction for Building and Area Level Services" Phase 3 — the rendering window for one service on
 * one area.
 *
 * Erik: "the user should be able to specify a service rendering start and end date as well - not per
 * meter, but per service rendered to the building area."
 *
 * Both bounds are optional. Blank start means rendered from the beginning, blank end means still being
 * rendered — which is how every service behaved before this existed, so leaving both blank changes
 * nothing.
 */
function ServiceRenderingDates(props) {
    var _this = this;
    var _a, _b;
    var clientId = props.clientId, userId = props.userId, serviceId = props.serviceId, serviceName = props.serviceName, areaId = props.areaId, rendering = props.rendering, onSaved = props.onSaved;
    var _c = (0, react_2.useState)((rendering === null || rendering === void 0 ? void 0 : rendering.renderStartDate) ? rendering.renderStartDate.slice(0, 10) : ""), start = _c[0], setStart = _c[1];
    var _d = (0, react_2.useState)((rendering === null || rendering === void 0 ? void 0 : rendering.renderEndDate) ? rendering.renderEndDate.slice(0, 10) : ""), end = _d[0], setEnd = _d[1];
    var _e = (0, service_1.useSetAreaRenderingMutation)(), setAreaRendering = _e[0], isLoading = _e[1].isLoading;
    var isDirty = ((_a = rendering === null || rendering === void 0 ? void 0 : rendering.renderStartDate) !== null && _a !== void 0 ? _a : "").slice(0, 10) !== start || ((_b = rendering === null || rendering === void 0 ? void 0 : rendering.renderEndDate) !== null && _b !== void 0 ? _b : "").slice(0, 10) !== end;
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, err_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (start && end && end < start) {
                        (0, react_1.addToast)({ title: "Check the dates", description: "The end date cannot be before the start date.", color: "danger" });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, setAreaRendering({
                            serviceId: serviceId,
                            clientId: clientId,
                            areaId: areaId,
                            renderStartDate: start || null,
                            renderEndDate: end || null,
                            performedBy: userId,
                        }).unwrap()];
                case 2:
                    res = _b.sent();
                    if (res.success) {
                        (0, react_1.addToast)({ title: "Saved", description: "Rendering dates saved for ".concat(serviceName, "."), color: "success" });
                        onSaved();
                    }
                    else {
                        (0, react_1.addToast)({ title: "Error", description: res.message || "Could not save the dates.", color: "danger" });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    message = ((_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred.";
                    (0, react_1.addToast)({ title: "Error", description: message, color: "danger" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "mt-3 flex flex-wrap items-end gap-2 rounded-lg border border-gray-200 bg-white p-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("span", { className: "mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500", children: "Service rendering" }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-gray-400", children: "Leave blank for open-ended. Swapping a meter does not change these." })] }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "date", size: "sm", variant: "bordered", label: "Rendered from", className: "max-w-[11rem]", value: start, onValueChange: setStart }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "date", size: "sm", variant: "bordered", label: "Rendered until", className: "max-w-[11rem]", value: end, onValueChange: setEnd }), (rendering === null || rendering === void 0 ? void 0 : rendering.endedByMeterRemoval) && ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: "warning", children: "Ended automatically \u2014 last meter removed" })), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "primary", variant: "flat", isDisabled: !isDirty, isLoading: isLoading, onPress: handleSave, children: "Save dates" })] }));
}
